import $ from 'jquery'

let mountedRoot
let cleanup

function initializeAdminDeals() {
  const root = document.getElementById('admin-deals-page')
  if (root === mountedRoot) return
  if (cleanup) cleanup()
  if (!root) return
  mountedRoot = root
  const form = root.querySelector('#admin-deals-filter-form')
  const results = root.querySelector('#admin-recent-deals-table')
  const pagination = root.querySelector('#admin-deals-pagination')
  const status = root.querySelector('#admin-deals-table-status')
  const $root = $(root)
  const $date = $root.find('.daterange')
  const $country = $root.find('.admin-countries')
  let active = true
  let timer
  let request
  let version = 0

  const setBusy = busy => {
    if (busy) results.setAttribute('aria-busy', 'true')
    else results.removeAttribute('aria-busy')
    status.textContent = busy ? root.dataset.loadingText : ''
  }
  const cancelRequest = () => {
    version += 1
    if (request) request.abort()
    request = null
    setBusy(false)
  }
  const initializeTable = () => {
    const table = results.querySelector('.admin-datatable')
    if (!table) return
    window.CarrylugDataTables.ready().then(() => {
      if (!active || !table.isConnected || $.fn.DataTable.isDataTable(table)) return
      $(table).DataTable({
        rowReorder: true, searching: false, paging: false, order: [[1, 'desc']],
        language: {emptyTable: root.dataset.emptyTable}
      })
    }).catch(() => { /* The rendered HTML table remains usable without the plugin. */ })
  }
  const tableUrl = page => {
    const url = new URL(form.action, window.location.href)
    new FormData(form).forEach((value, key) => url.searchParams.set(key, value))
    if (page) url.searchParams.set('recent_deals_page', page)
    else url.searchParams.delete('recent_deals_page')
    return url
  }
  const fetchTable = url => {
    clearTimeout(timer)
    cancelRequest()
    const current = version
    request = new AbortController()
    setBusy(true)
    fetch(url, {credentials: 'same-origin', signal: request.signal, headers: {Accept: 'application/json'}})
      .then(response => { if (!response.ok) throw new Error('Request failed'); return response.json() })
      .then(data => {
        if (!active || current !== version) return
        const table = results.querySelector('.admin-datatable')
        if (table && $.fn.DataTable && $.fn.DataTable.isDataTable(table)) $(table).DataTable().destroy()
        results.innerHTML = data.table
        pagination.innerHTML = data.pagination
        root.querySelectorAll('[data-deal-count]').forEach(element => {
          element.textContent = String(data.summary[element.dataset.dealCount] || 0)
        })
        initializeTable()
      })
      .catch(error => {
        if (active && current === version && error.name !== 'AbortError') {
          status.textContent = root.dataset.errorText
        }
      })
      .finally(() => {
        if (!active || current !== version) return
        results.removeAttribute('aria-busy')
        if (status.textContent === root.dataset.loadingText) status.textContent = ''
        request = null
      })
  }
  $root.on('submit.adminDeals', '#admin-deals-filter-form', event => {
    event.preventDefault()
    fetchTable(tableUrl())
  })
  $root.on('input.adminDeals', '#admin-deals-filter-form input[name="query"]', function() {
    clearTimeout(timer)
    cancelRequest()
    if (this.value.length > 0 && this.value.length < 3) return
    timer = setTimeout(() => fetchTable(tableUrl()), 300)
  })
  $root.on('change.adminDeals', '#admin-deals-filter-form select', () => fetchTable(tableUrl()))
  const paginate = event => {
    if (event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return
    const link = event.target.closest('#admin-deals-pagination a[href]')
    if (!link || link.closest('.disabled, .active') || link.getAttribute('href') === '#') return
    event.preventDefault()
    // Handle pagination before Rails UJS can execute an older script response.
    event.stopPropagation()
    fetchTable(tableUrl(new URL(link.href).searchParams.get('recent_deals_page')))
  }
  root.addEventListener('click', paginate, true)

  if ($.fn.daterangepicker) {
    $date.daterangepicker({autoUpdateInput: false, locale: {cancelLabel: 'Clear', format: 'DD/MM/YYYY'}})
    $date.on('apply.daterangepicker.adminDeals', function(event, picker) {
      $(this).val(`${picker.startDate.format('DD/MM/YYYY')} - ${picker.endDate.format('DD/MM/YYYY')}`)
      fetchTable(tableUrl())
    }).on('cancel.daterangepicker.adminDeals', function() {
      $(this).val('')
      fetchTable(tableUrl())
    })
  }
  if ($.fn.select2) {
    $country.select2({
      placeholder: $country.data('placeholder'), allowClear: true, width: 'resolve',
      ajax: {
        url: $country.data('options-url'), dataType: 'json', delay: 250,
        data: params => ({q: params.term || '', page: params.page || 1}),
        processResults: data => data
      }
    })
  }
  initializeTable()
  cleanup = () => {
    active = false
    clearTimeout(timer)
    cancelRequest()
    $root.off('.adminDeals')
    root.removeEventListener('click', paginate, true)
    $date.off('.adminDeals')
    const picker = $date.data('daterangepicker')
    if (picker) picker.remove()
    if ($country.hasClass('select2-hidden-accessible')) $country.select2('destroy')
    mountedRoot = null
    cleanup = null
  }
}

$(initializeAdminDeals)
document.addEventListener('turbolinks:load', initializeAdminDeals)
document.addEventListener('turbolinks:before-cache', () => { if (cleanup) cleanup() })
